<div>
	<mat-card-title class="h5">
		Counts Status
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
	</mat-card-title>
	<mat-divider *ngIf="showMatDivider"> </mat-divider>

	<div class="margin-vertical-sm"
		*ngFor="let performancePeriod of performancePeriods; let first = first; let last = last;"
		[hidden]="performancePeriod !== currentPerformancePeriod">

		<mat-icon class="v-align-middle icon-1-5x margin-horizontal-xs"
			[class]="{'cursor-pointer': !first, 'disabled': first}" [color]="first ? '' : 'primary'"
			(click)="first ? null : changePerformancePeriod(performancePeriodIndex, -1)">
			chevron_left
		</mat-icon>
		<span class="performance-period-size v-align-middle">{{currentPerformancePeriod}}</span>
		<mat-icon class="v-align-middle icon-1-5x margin-horizontal-xs"
			[class]="{'cursor-pointer': !last, 'disabled': last}" [color]="last ? '' : 'primary'"
			(click)="last ? null : changePerformancePeriod(performancePeriodIndex, 1)">
			chevron_right
		</mat-icon>
	</div>

	<div *ngIf="!isLoading && currentPerformancePeriod">
		<span *ngFor="let category of eligibilityCategoryTypes; let index = index; let first = first; let last = last;"
			class="padding-horizontal-xs" [matTooltip]="category.TOOLTIP" matTooltipClass="multiline-tooltip"
			matTooltipPosition="above">
			<mat-icon class="v-align-middle"
				[color]="eligibilityCategoryTypes[index] && eligibilityCategoryTypes[index][currentPerformancePeriod] && eligibilityCategoryTypes[index][currentPerformancePeriod]['ID'] === 1 ? 'primary' : ''">
				{{eligibilityCategoryTypes[index] && eligibilityCategoryTypes[index][currentPerformancePeriod] &&
				eligibilityCategoryTypes[index][currentPerformancePeriod]['ID'] === 1 ? 'check_box' :
				'check_box_outline_blank'}}
			</mat-icon>
			{{category.DESCRIPTION}}
		</span>
	</div>

	<div class="margin-top-md danger bold" *ngIf="!eip">
		{{eipReason}}
	</div>
</div>